import { render, staticRenderFns } from "./FuelVoucher.vue?vue&type=template&id=635659f2"
import script from "./FuelVoucher.vue?vue&type=script&lang=js"
export * from "./FuelVoucher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports